import type { Spot, SpotPrice } from "../types";

export function dayPrices(spot: Spot): SpotPrice[] {
  return spot.prices.filter((p) =>
    ["per_rod_per_day", "per_rod_half_day", "per_day"].includes(p.unit),
  );
}

export function lowestDayPrice(spot: Spot): SpotPrice | null {
  const daily = dayPrices(spot);
  if (!daily.length) return null;
  return daily.reduce<SpotPrice>((min, p) => (p.amount < min.amount ? p : min), daily[0]);
}

export interface HeadlineCardPrice {
  amount: number;
  label: string;
}

/** Pick the headline annual-card price for spots without a day price.
 *  fishpartner publishes its own membership tier — that wins for FP spots. */
export function headlineCardPrice(
  spot: Spot,
  fpLabel: string,
  veidikortidLabel: string,
): HeadlineCardPrice | null {
  const cards = spot.prices.filter((p) => p.unit === "per_card_year");
  if (!cards.length) return null;
  if (spot.source?.name === "fishpartner.is") {
    return { amount: cards[0].amount, label: fpLabel };
  }
  return { amount: 9900, label: "Veiðikortið " + veidikortidLabel };
}

export function priceUnitLabel(
  unit: SpotPrice["unit"],
  labels: {
    perRodDay: string;
    perRodHalfDay: string;
    perDay: string;
    perSeason: string;
    perCardYear: string;
    perYear: string;
  },
): string {
  switch (unit) {
    case "per_rod_per_day":
      return labels.perRodDay;
    case "per_rod_half_day":
      return labels.perRodHalfDay;
    case "per_day":
      return labels.perDay;
    case "per_season":
      return labels.perSeason;
    case "per_card_year":
      return labels.perCardYear;
    case "per_year":
      return labels.perYear;
    default:
      return "";
  }
}
